export default __webpack_public_path__ + "static/media/047-kick scooter.38c0ac43.svg";